import React, {useState, useEffect, useRef} from 'react';
import {Tooltip} from "primereact/tooltip";
import {withTranslation} from 'react-i18next';
import {useNavigate, useParams} from "react-router-dom";
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {ConfirmDialog} from "primereact/confirmdialog";
import {addLocale, locale} from "primereact/api";
import {InputText} from "primereact/inputtext";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";

import HelpComponent from "../HelpComponent";
import {Badge} from "primereact/badge";
import fileDownload from "js-file-download";

const _FM_GuestListComponent = (props) => {
  const {t} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [guest, setGuest] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(10);
  const dt = useRef(null);
  const filterTextMatchModes = [
    {label: t('filter_like'), value: 'like'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
  ]
  const filterNumberMatchModes = [
    {label: t('filter_between_number'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const filterDateMatchModes = [
    {label: t('filter_between_date'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const [lazyParams, setLazyParams] = useState({
    first: Number(localStorage.getItem('guest_first')) || 0,
    rows: Number(localStorage.getItem('guest_rows')) || rows,
    page: Number(localStorage.getItem('guest_page')) || 0,
    sortField: localStorage.getItem('guest_sortField') || 'id',
    sortOrder: Number(localStorage.getItem('guest_sortOrder')) || -1,
    filters: JSON.parse(localStorage.getItem('guest_filters')) || null,
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest" + query,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setGuest(response.data.data.items);
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: 10, value: 10},
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 200, value: 200}
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', guestSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    />
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', guestSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-eye" className="p-button-sm p-button-secondary p-mr-2"
                tooltip={t('show')}
                disabled={rowData.deleted_at_snapshot}
                tooltipOptions={{position: 'left'}}
                onClick={() => {
                  navigate('/guest/read/' + rowData.id)
                }}/>
        <Button icon="pi pi-pencil" className="p-button-sm  p-button-warning p-mr-2"
                tooltip={t('edit')}
                disabled={rowData.deleted_at_snapshot}
                tooltipOptions={{position: 'left'}}
                onClick={() => {
                  navigate('/guest/update/' + rowData.id)
                }}/>
        {rowData && rowData.deleted_at_snapshot ? (
          <Button icon="pi pi-undo" className="p-button-sm p-button-success"
                  tooltip={t('restore')}
                  tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    axios({
                      method: 'get',
                      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest/" + rowData.id + "/restore",
                      params: {},
                      headers: {
                        'Authorization': 'Bearer ' + Cookies.get("userToken"),
                        "Sys-name": Cookies.get("instanceId"),
                        "Preferred-locale": Cookies.get("language")
                      }
                    })
                      .then(response => {
                        window.App.toastShow('success', t('success_restore'),);
                        loadLazyData();
                      })
                      .catch(error => {
                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                      })
                  }}
          />
        ) : (
          <>
            <Button icon="pi pi-trash" className="p-button-sm  p-button-danger"
                    tooltip={t('delete')}
                    tooltipOptions={{position: 'left'}}
                    onClick={() => {
                      window.App.setState({[`confirmDelete${rowData.id}`]: true})
                    }}
            />
            <ConfirmDialog group="declarative" visible={window.App.state[`confirmDelete${rowData.id}`]}
                           acceptLabel={t('yes')} rejectLabel={t('no')}
                           onHide={() => {
                             window.App.setState({[`confirmDelete${rowData.id}`]: false})
                           }}
                           message={t('confirm_delete')} header={t('confirm_delete')} icon="pi pi-exclamation-triangle"
                           accept={() => {
                             window.App.delete('guest', rowData.id)
                               .then(response => {
                                 window.App.toastShow('success', t('success_delete'),);
                                 loadLazyData();
                               })
                               .catch(error => {
                                 window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                               })
                           }}
                           reject={() => {
                             window.App.setState({[`confirmDelete${rowData.id}`]: false})
                           }}/>
          </>
        )}
      </React.Fragment>
    );
  }

  addLocale('default', {
    clear: t('filter_clear'),
    apply: t('filter_apply'),
  });
  locale('default');

  useEffect(() => {
    if (lazyParams.filters) {
      document.getElementById('search').value = '';
      localStorage.setItem('guest_filters', JSON.stringify(lazyParams.filters))
      if (lazyParams.sortField) {
        localStorage.setItem('guest_sortField', lazyParams.sortField)
      }
      if (lazyParams.sortOrder) {
        localStorage.setItem('guest_sortOrder', lazyParams.sortOrder)
      }
      if (lazyParams.first >= 0) {
        localStorage.setItem('guest_first', lazyParams.first)
      }
      if (lazyParams.page >= 0) {
        localStorage.setItem('guest_page', lazyParams.page)
      }
      if (lazyParams.rows) {
        localStorage.setItem('guest_rows', lazyParams.rows)
        setRows(lazyParams.rows)
      }
    }
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderGuestList])

  return (
    <>
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-3 p-col-align-center"}>
          <h2 className={"p-m-0"}>{t('guest_list')}</h2>
        </div>
        <div className={"p-col-12 p-lg-9 p-text-right p-col-align-center"}>
          <HelpComponent type={"site"} position={"UNDER_HELP_BUTTON"}/>
          {Cookies.get('roles') && (Cookies.get('roles').toString().includes('ROLE_GUEST_CRUD_READ') || Cookies.get('roles').toString().includes('_ADMIN')) &&
            <Button type="button" label={t('export_csv')} icon={"pi pi-download"}
                    onClick={() => {
                      setLoading(true)
                      let query = window.App.transformQueryParams(lazyParams)
                      axios.get(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest/export" + query,
                        {
                          responseType: 'blob',
                          params: {},
                          headers: {
                            'Authorization': 'Bearer ' + Cookies.get("userToken"),
                            "Sys-name": Cookies.get("instanceId"),
                            "Preferred-locale": Cookies.get("language")
                          }
                        })
                        .then(response => {
                          setLoading(false)
                          const contentDisposition = response?.headers?.['content-disposition'] || response?.headers?.['Content-Disposition'];
                          const utf8FileNameMatch = contentDisposition?.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
                          const fileNameMatch = contentDisposition?.match(/filename\s*=\s*("?)([^";]+)\1/i);
                          const headerFileName = utf8FileNameMatch?.[1]
                            ? decodeURIComponent(utf8FileNameMatch[1].trim().replace(/^["']|["']$/g, ''))
                            : fileNameMatch?.[2]?.trim();
                          fileDownload(response.data, headerFileName || 'guests-' + moment.utc().local().format('YYYY-MM-DD') + '.csv');
                        })
                        .catch(error => {
                          setLoading(false)
                          window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error.response)
                        })
                    }}
                    className="p-button-warning p-ml-2"/>
          }
          {Cookies.get('roles') && (Cookies.get('roles').toString().includes('ROLE_GUEST_CRUD_READ') || Cookies.get('roles').toString().includes('_ADMIN')) &&
            <Button type="button" label={t('export_xlsx')} icon={"pi pi-download"}
                    onClick={() => {
                      setLoading(true)
                      let query = window.App.transformQueryParams(lazyParams)
                      const queryPrefix = query && query.includes('?') ? '&' : '?'
                      axios.get(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest/export" + query + queryPrefix + "format=xlsx",
                        {
                          responseType: 'blob',
                          params: {},
                          headers: {
                            'Authorization': 'Bearer ' + Cookies.get("userToken"),
                            "Sys-name": Cookies.get("instanceId"),
                            "Preferred-locale": Cookies.get("language")
                          }
                        })
                        .then(response => {
                          setLoading(false)
                          const contentDisposition = response?.headers?.['content-disposition'] || response?.headers?.['Content-Disposition'];
                          const utf8FileNameMatch = contentDisposition?.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
                          const fileNameMatch = contentDisposition?.match(/filename\s*=\s*("?)([^";]+)\1/i);
                          const headerFileName = utf8FileNameMatch?.[1]
                            ? decodeURIComponent(utf8FileNameMatch[1].trim().replace(/^["']|["']$/g, ''))
                            : fileNameMatch?.[2]?.trim();
                          fileDownload(response.data, headerFileName || 'guests-' + moment.utc().local().format('YYYY-MM-DD') + '.xlsx');
                        })
                        .catch(error => {
                          setLoading(false)
                          window.App.toastShow('error', t('error'), error?.response?.data?.message || error.toString(), '', error.response)
                        })
                    }}
                    className="p-button-warning p-ml-2"/>
          }
          {localStorage.getItem('guest_filters') &&
              <a style={{color: "red"}} className={"p-button p-button-danger p-ml-2"}
                 onClick={() => {
                   localStorage.removeItem('guest_filters')
                   localStorage.removeItem('guest_sortField')
                   localStorage.removeItem('guest_sortOrder')
                   localStorage.removeItem('guest_rows')
                   localStorage.removeItem('guest_page')
                   localStorage.removeItem('guest_first')
                   setLazyParams({
                     ...lazyParams,
                     filters: null
                   })
                 }}
              >
                <i className={"pi pi-exclamation-triangle"}></i>&nbsp;{t('clear_filter')}
              </a>
          }
          {lazyParams && lazyParams.is_active === 0 ? (
            <Button type="button" icon={"pi pi-eye-slash"}
                    label={t('hide_deleted')}
                    onClick={() => {
                      let _lazyParams = lazyParams
                      delete lazyParams.is_active
                      setLazyParams(_lazyParams)
                      loadLazyData()
                    }}
                    className="p-button-danger p-ml-2"/>
          ) : (
            <Button type="button" icon={"pi pi-eye"}
                    label={t('show_deleted')}
                    onClick={() => {
                      setLazyParams({
                        ...lazyParams,
                        is_active: 0
                      })
                    }}
                    className="p-button-success p-ml-2"/>
          )}
          <span className="p-input-icon-left p-ml-2">
              <i className="pi pi-search"/>
              <InputText id="search"
                         placeholder={t('search')}
                         onChange={(e) => {
                           clearTimeout(window.searchTimeout)
                           window.searchTimeout = setTimeout(function () {
                             localStorage.removeItem('guest_filters')
                             localStorage.removeItem('guest_sortField')
                             localStorage.removeItem('guest_sortOrder')
                             localStorage.removeItem('guest_rows')
                             localStorage.removeItem('guest_page')
                             localStorage.removeItem('guest_first')
                             setLazyParams({
                               ...lazyParams,
                               genericSearch: e.target.value,
                               filters: null
                             })
                           }, 1000)
                         }}
                         className={""}
              />
            </span>
        </div>
      </div>
      {/* <HelpComponent type={"list_box"} box={"guest"}/> */}
      <DataTable
        ref={dt}
        size={"small"}
        emptyMessage={t('empty_message')}
        value={guest} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows} emptyMessage={t('empty_message')}
        autoLayout={true}
        filterDisplay="menu"
        responsiveLayout={window.App.state.responsiveLayout}
        breakpoint="1365px"
        stripedRows
        dataKey="id"
        selectionMode={"single"}
        onRowDoubleClick={(rowData) => {
          if(!rowData.data.deleted_at_snapshot)
          navigate('/guest/update/' + rowData.data.id)
        }}
      >
        <Column field="lastname" sortable header={t('lastname')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}
        ></Column>
        <Column field="firstname" sortable header={t('firstname')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}
        ></Column>
        <Column field="accommodation.name" sortable header={t('accommodation')}
                body={(rowData) => <><span className={"p-text-nowrap"}>{rowData?.accommodation?.name}<span className={"tt-auto-invoice p-ml-2"} data-pr-tooltip={rowData?.accommodation?.auto_invoice_on_check_out === 'CREATE_AND_SYNC' ? t('auto_invoice_tooltip_active') : t('auto_invoice_tooltip_inactive')}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={"auto-invoice-icon"} style={{ color: rowData?.accommodation?.auto_invoice_on_check_out === 'CREATE_AND_SYNC' ? '#0abb87' : '#dddddd', position: 'relative', bottom: '-3px' }}><path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8" /><path d="M5 21l2.5-1.5L10 21l2.5-1.5L14 21l1.5-1" /><path d="M9 7h6" /><path d="M9 11h4" /><path d="M18 14a3 3 0 1 0 3 3" /><path d="M21 20v-3h-3" /></svg></span></span><Tooltip target=".tt-auto-invoice"/></>}
        ></Column>
        <Column field="birth_date" sortable header={t('birth_date')}
                filter
                filterMatchMode="between"
                filterMatchModeOptions={filterDateMatchModes}
                body={(rowData) => {
                  if (rowData.birth_date !== null) {
                    return (
                      <span>{moment.utc(rowData.birth_date).local().format(t('YYYY-MM-DD'))}</span>
                    )
                  }
                }}></Column>
        {/*<Column field="gender" sortable header={t('gender')}*/}
        {/*        filter*/}
        {/*        filterMatchMode="like"*/}
        {/*        filterMatchModeOptions={filterTextMatchModes}*/}
        {/*        body={(rowData) =>{*/}
        {/*          if(rowData.gender) {*/}
        {/*            return(*/}
        {/*              <>*/}
        {/*                {t(rowData.gender.toLowerCase())}*/}
        {/*              </>*/}
        {/*            )*/}
        {/*          }*/}
        {/*        }}*/}
        {/*></Column>*/}
        <Column field="company_name" sortable header={t('company_name')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}
        ></Column>
        {/*<Column field="zip_code" sortable header={t('zip_code')}*/}
        {/*        filter*/}
        {/*        filterMatchMode="like"*/}
        {/*        filterMatchModeOptions={filterTextMatchModes}*/}
        {/*></Column>*/}
        {/*<Column field="address" sortable header={t('address')}*/}
        {/*        filter*/}
        {/*        filterMatchMode="like"*/}
        {/*        filterMatchModeOptions={filterTextMatchModes}*/}
        {/*></Column>*/}
        <Column field="status" header={t('status')} sortable
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}
                body={(rowData) => {
                  return(
                    <>
                      {rowData.status ? (
                        rowData.status.toLowerCase() === 'will_arrive' ? (
                          <Badge value={t('will_arrive')} severity="success" style={{backgroundColor: '#f1eea5', color: '#5f656b', width: '100%'}}></Badge>
                        ) : rowData.status.toLowerCase() === 'checked_in' ? (
                          <Badge value={t('checked_in')} severity="success" style={{backgroundColor: '#3ec0e9', width: '100%'}}></Badge>
                        ) : rowData.status.toLowerCase() === 'checked_out' ? (
                          <Badge value={t('checked_out')} severity="success" style={{backgroundColor: '#0abb87', width: '100%'}}></Badge>
                        ) : rowData.status.toLowerCase() === 'no_show' ? (
                          <Badge value={t('no_show')} severity="warning" style={{backgroundColor: '#8a2be2', color: '#fff', width: '100%'}}></Badge>
                        ) : (
                          <Badge value={t('unknown_status')} severity="warning" style={{backgroundColor: '#ccc', width: '100%'}}></Badge>
                        )
                      ) : (
                        <Badge value={t('no_status')} severity="warning" style={{backgroundColor: '#ccc', width: '100%'}}></Badge>
                      )}
                    </>
                  )
                }}
        ></Column>
        <Column field="created_at_snapshot" sortable header={t('created_at')}
                filter
                filterField={"created_at"}
                sortField={"created_at"}
                filterMatchMode="between"
                filterMatchModeOptions={filterDateMatchModes}
                body={(rowData) => {
                  if (rowData.created_at_snapshot !== null) {
                    return (
                      <span>{moment.utc(rowData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                    )
                  }
                }}></Column>
        <Column field="updated_at_snapshot" sortable header={t('updated_at')}
                filterField={"updated_at"}
                sortField={"updated_at"}
                filter
                filterMatchMode="between"
                filterMatchModeOptions={filterDateMatchModes}
                body={(rowData) => {
                  if (rowData.updated_at_snapshot !== null) {
                    return (
                      <span>{moment.utc(rowData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                    )
                  }
                }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-nowrap p-text-right"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(_FM_GuestListComponent);
